export default "__VITE_ASSET__bupM8eKD__"